import { RouteObject } from "react-router-dom";
import { AuthLayout } from "../routes/AuthLayout";
import { AuthRoutesConfig } from "./config";

export const AuthNavigationRoutes: RouteObject = {
  path: `${AuthRoutesConfig.idamLogin}/*`,
  element: <AuthLayout />,
};
